module.exports = __webpack_public_path__ + "img/18.eceade65.png";